import React from 'react';
import { motion } from 'framer-motion';

const TrustIndicators = () => (
  <motion.div
    initial={{ opacity: 0, y: 30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay: 1 }}
    className="grid grid-cols-3 gap-8 max-w-2xl mx-auto"
  >
    <div className="text-center p-6 rounded-2xl bg-slate-800/30 backdrop-blur-sm border border-slate-700/50">
      <div className="text-4xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 text-transparent bg-clip-text mb-2">500+</div>
      <div className="text-slate-400 text-sm">Projekte</div>
    </div>
    <div className="text-center p-6 rounded-2xl bg-slate-800/30 backdrop-blur-sm border border-slate-700/50">
      <div className="text-4xl font-bold bg-gradient-to-r from-yellow-400 to-orange-400 text-transparent bg-clip-text mb-2">5.0</div>
      <div className="text-slate-400 text-sm">Bewertung</div>
    </div>
    <div className="text-center p-6 rounded-2xl bg-slate-800/30 backdrop-blur-sm border border-slate-700/50">
      <div className="text-4xl font-bold bg-gradient-to-r from-green-400 to-emerald-400 text-transparent bg-clip-text mb-2">24h</div>
      <div className="text-slate-400 text-sm">Service</div>
    </div>
  </motion.div>
);

export default TrustIndicators;
